var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 10.7498V14.2498C13.3337 17.1665 12.167 18.3332 9.25033 18.3332H5.75033C2.83366 18.3332 1.66699 17.1665 1.66699 14.2498V10.7498C1.66699 7.83317 2.83366 6.6665 5.75033 6.6665H9.25033C12.167 6.6665 13.3337 7.83317 13.3337 10.7498Z",
    stroke: "#00535C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 5.74984V9.24984C18.3337 12.1665 17.167 13.3332 14.2503 13.3332H13.3337V10.7498C13.3337 7.83317 12.167 6.6665 9.25033 6.6665H6.66699V5.74984C6.66699 2.83317 7.83366 1.6665 10.7503 1.6665H14.2503C17.167 1.6665 18.3337 2.83317 18.3337 5.74984Z",
    stroke: "#00535C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.ecb146e388d699ddcfcf2459409069c5.svg";
export { ForwardRef as ReactComponent };